import React from 'react';

import withPageComponents from '../../page/components/with-page-components';
import JsonLd from '../../shared/components/json-ld';

const EMPTY_OBJECT = {};

const homeBanner = ({ homePageSettings = EMPTY_OBJECT, proxyHost = 'https://www.hp.com', siteConfig }) => {
    const { schemaMarkup: schemaSettings } = homePageSettings;
    //remove key from component value and map type to @type
    const { key, type, ...rest } = schemaSettings || {};
    const { basename = '/us-en/shop' } = siteConfig;
    //convert 'type' to '@type' in rest props and remove key attribute
    let restProps = {};
    try {
        restProps = JSON.parse(
            JSON.stringify(rest || {}, (prop, value) => (prop === 'key' ? undefined : value)).replace(
                /"type"\s*:/g,
                '"@type":',
            ),
        );
    } catch (e) {}
    const schemaMarkup = {
        '@type': type,
        url: `${proxyHost}${basename}`,
        ...restProps,
    };

    return !!type && <JsonLd schemaMarkup={schemaMarkup} />;
};

export default withPageComponents(homeBanner, { components: ['homePageSettings'], proxyHost: true, siteConfig: true });
